import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import AllPolicySection from "../../../../policies/components/AllPolicySection/AllPolicySection";
import {
  operatorTravellersFilterOptions,
  operatorTripsFilterOptions,
} from "../../../constants/operatorListConstants";

const PolicedIssuedByOperator = () => {
  const operatorId = useSelector((state) => state.operatorProfile?.operator?.id);
  const [viewMode, setViewMode] = useState("trips");

  const endpoints = useMemo(
    () => ({
      trips: `issuance/policies/user-specific/trips/?operator_id=${operatorId}`,
      travellers: `issuance/policies/user-specific/travellers/?operator_id=${operatorId}`,
    }),
    [operatorId]
  );

  const pathOverrides = useMemo(
    () => ({
      tripDetails: (row) => `/operator/operator-details/policies-issued/${row.id}`,
      travellerDetails: (row) => `/operator/operator-details/policies-issued/${row.id}`,
      endorsement: (row) => `/issuance/endorsement/${row.id}`,
    }),
    []
  );

  if (!operatorId) return null;

  return (
    <AllPolicySection
      tripsEndpoint={endpoints.trips}
      travellersEndpoint={endpoints.travellers}
      viewMode={viewMode}
      onViewChange={setViewMode}
      showStats={false}
      pathOverrides={pathOverrides}
      tripsFilterOptions={operatorTripsFilterOptions}
      travellersFilterOptions={operatorTravellersFilterOptions}
    />
  );
};

export default PolicedIssuedByOperator;
